import { Appointment, Car, CarSliceState, QcInformation, UpdateCarQcInformation } from "../types";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { getCarAppointmentsApi, getCarQcInformationApi, getCarsApi, getCarsViewsAndFavoritesAPI, updateCarQcInformationApi } from "service/apis";
import { AppointmentsQuery, CarQuery } from "service/queries";
import { ApiResponse } from "types";
import { dispatch } from "./../../../store/store";
import { CAR_SORT_OPTIONS, CAR_STATUS_TYPE } from "constants/constants";

const initialState: CarSliceState = {
	sort: CAR_SORT_OPTIONS[0],
	total: 0,
};

export const carSlice = createSlice({
	name: "car",
	initialState,
	reducers: {
		setListCars: (state, action) => {
			state.list = action.payload.data;
			state.total = action.payload.total;
		},
		setCarsSort: (state, action) => {
			state.sort = action.payload;
		},
		setCarAppointments: (state, action) => {
			state.appointments = action.payload.data;
			state.appointmentsTotal = action.payload.total;
		},
		setQcInformation: (state, action) => {
			state.qcInformation = action.payload.data;
		}
	},
});

export const selectListCar = (state: RootState) => state.car.list;
export const selectCarTotal = (state: RootState) => state.car.total;
export const selectCarSort = (state: RootState) => state.car.sort;
export const selectCarAppointmentsTotal = (state: RootState) => state.car.appointmentsTotal;
export const selectCarAppointments = (state: RootState) => state.car.appointments;
export const selectQcInformation = (state: RootState) => state.car.qcInformation;

export const { setListCars, setCarsSort, setCarAppointments, setQcInformation } = carSlice.actions;

export default carSlice.reducer;

export const getListCarAsync = (
	query: CarQuery,
	successCallback?: (result: Car[]) => void,
	failureCallback?: (data: any) => void,
) => {
	getCarsApi(query)
		.then((result: ApiResponse<Car[]>) => {
			result?.data?.map((ele) => {
				if(ele.status === CAR_STATUS_TYPE.SOLD_BY_MERCHANT) {
					ele.status = CAR_STATUS_TYPE.SOLD_BY_MERCHANT.replaceAll("_", " ");
				};
			});
			dispatch(setListCars(result));
			successCallback && successCallback(result.data);
		})
		.catch(error => {
			failureCallback && failureCallback(error);
		});
};

export const getCarsViewsAndFavoritesAsync = (
	ids: number[],
	successCallback?: (result: any) => void,
	failureCallback?: (data: any) => void,
) => {
	getCarsViewsAndFavoritesAPI(ids)
		.then((result: any) => {
			if (result.data === null) {
				return successCallback?.({});
			}
			const parsedCarsViewsAndFavorites = new Map<number, {favorites: number, views: number}>();
			result.data.forEach((item: { [x: number]: {id: number, favorites: number, views: number} }) => {
				const [key, value] = Object.entries(item)[0] as [string, {id: number, favorites: number, views: number}];
				parsedCarsViewsAndFavorites.set(Number(key), { favorites: value.favorites, views: value.views });
			});
			successCallback && successCallback(parsedCarsViewsAndFavorites);
		})
		.catch(error => {
			failureCallback && failureCallback(error);
		});
};

export const getCarAppointmentsAsync = (
	id: string | number | undefined,
	query: AppointmentsQuery,
	successCallback?: () => void,
	failureCallback?: (data: any) => void,
) => {
	getCarAppointmentsApi(id, query)
		.then((result: ApiResponse<Appointment[]>) => {
			dispatch(setCarAppointments(result));
			successCallback && successCallback();
		})
		.catch(error => {
			failureCallback && failureCallback(error);
		});
};

export const getCarQcInformationAsync = (
	id?: string,
	successCallback?: (qcInformation: QcInformation) => void,
	failureCallback?: (data: any) => void,
) => {
	getCarQcInformationApi(id)
		.then((result: ApiResponse<QcInformation>) => {
			dispatch(setQcInformation(result));
			successCallback && successCallback(result.data);
		})
		.catch(error => {
			failureCallback && failureCallback(error);
		});
};

export const updateCarQcInformationAsync = (
	id?: string,
	body?: UpdateCarQcInformation,
	successCallback?: () => void,
	failureCallback?: (data: any) => void,
) => {
	updateCarQcInformationApi(id, body)
		.then((result: ApiResponse<QcInformation>) => {
			dispatch(setQcInformation(result));
			successCallback && successCallback();
		})
		.catch(error => {
			failureCallback && failureCallback(error);
		});
};
